module.exports = __webpack_public_path__ + "img/video_chat_reminders.0a5e964c.svg";